import { FC, useMemo, useRef } from 'react';
import ru from 'date-fns/locale/ru';
import { observer } from 'mobx-react-lite';
import ReactDatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';
import { SVG } from 'components/svg';
import { SCalendarIcon, SDatePickerWrapper } from './styled';
import { Icons } from 'assets';

registerLocale('ru', ru);

const DATE_FORMATS = [
  'dd.MM.yyyy',
  'dd MMMM yyyy HH:mm',
  'dd.MM.yyyy HH:mm',
  'dd MMMM yyyy',
  'dd MMMM',
] as const;

type DateFormat = (typeof DATE_FORMATS)[number];

interface DatepickerProps extends Omit<ReactDatePickerProps, 'dateFormat'> {
  dateFormat?: DateFormat;
}

export const Datepicker: FC<DatepickerProps> = observer(
  ({ dateFormat, ...props }) => {
    const ref = useRef<ReactDatePicker>(null);
    const currentFormats: string[] = useMemo(
      () => (dateFormat ? [dateFormat, ...DATE_FORMATS] : [...DATE_FORMATS]),
      [dateFormat]
    );

    return (
      <SDatePickerWrapper>
        <ReactDatePicker
          ref={ref}
          locale="ru"
          dateFormat={currentFormats}
          yearDropdownItemNumber={100}
          scrollableYearDropdown
          scrollableMonthYearDropdown
          isClearable
          placeholderText="Выберите дату"
          popperProps={{ strategy: 'fixed' }}
          {...props}
        />

        {!props.selected && !props.inline && (
          <SCalendarIcon onClick={() => ref.current?.setOpen(true)}>
            <SVG src={Icons.Calendar} />
          </SCalendarIcon>
        )}
      </SDatePickerWrapper>
    );
  }
);

export default Datepicker;
